import { apiPost, apiGet } from '.';
import { MaintenanceModeOptions } from '../../../shared/types/admin';

export function setMaintenanceMode(opts: MaintenanceModeOptions): Promise<void> {
  return apiPost('/admin/maintenance', opts);
}

export function getMaintenanceMode(): Promise<MaintenanceModeOptions> {
  return apiGet('/admin/maintenance');
}
